import React from "react";
import styles from "./BetShuffleLoadingSkeleton.module.scss";

const BetShuffleLoadingSkeleton = () => {
  return (
    <div className={styles.betShuffleLoadingSkeleton}>
      <div>
        <div className={styles.betShuffleLoadingSquare} />
      </div>
      <div>
        <div className={styles.betShuffleLoadingText} />
        <div className={styles.betShuffleLoadingText} />
      </div>
      <div>
        <div className={styles.betShuffleLoadingButton} />
      </div>
    </div>
  );
};

export default BetShuffleLoadingSkeleton;
